import React from "react";
import MembershipPoliciesImg1 from "../../assets/images/membershipPoliciesImg1.svg";
import MembershipPoliciesImg2 from "../../assets/images/membershipPoliciesImg2.svg";
import MembershipPoliciesImg3 from "../../assets/images/membershipPoliciesImg3.svg";

import styles from "./PoliciesAndTerms.module.css";

export default function MemberPolicies() {
  return (
    <section
      className={`${styles.termsBlockContainer} ${styles.memberPolicies}`}
    >
      <div className={styles.container}>
        <h3>
          Membership <span> Policies</span>
        </h3>
        <h5>
          Comprehensive policies governing author and institutional memberships
          under the IMPARC framework.
        </h5>
        <div className={styles.cards}>
          <div className={styles.card}>
            <div className={styles.heading}>
              <figure>
                <img src={MembershipPoliciesImg1} alt={"Research Associate"} />
              </figure>
              <h4>Research Associate</h4>
            </div>
            <ul>
              <li>
                <h6>Eligibility Criteria</h6>
                <div className={styles.blueArrow}>
                  Ph.D. or equivalent academic qualification (or demonstrated research competence)
                </div>
                <div className={styles.blueArrow}>
                  Minimum peer-reviewed publication record
                </div>
                <div className={styles.blueArrow}>
                  Verified academic profile (ORCID / Scopus / Google Scholar preferred)
                </div>
              </li>
              <li>
                <h6>Benefits & Rights</h6>
                <div className={styles.blueArrow}>
                  Access to structured research network and mentorship ecosystem
                </div>
                <div className={styles.blueArrow}>
                  Eligibility for discounted or complimentary publication benefits (as applicable)
                </div>
                <div className={styles.blueArrow}>
                  Participation in conferences, Knowledge Series, and academic forums
                </div>
                <div className={styles.blueArrow}>
                  Visibility through IMPARC platforms and initiatives
                </div>
              </li>
              <li>
                <h6>Obligations</h6>
                <div className={styles.blueArrow}>
                  Maintain an active and authentic research profile
                </div>
                <div className={styles.blueArrow}>
                  Adhere to ethical research and citation standards
                </div>
                <div className={styles.blueArrow}>
                  Participate in peer-review or academic contribution processes when invited
                </div>
                <div className={styles.blueArrow}>
                  Comply with IMPARC publishing and conduct guidelines
                </div>
              </li>
            </ul>
            <button className={styles.cardBtn}>View Full Policy</button>
          </div>
          <div className={styles.card}>
            <div className={styles.heading}>
              <figure>
                <img
                  src={MembershipPoliciesImg2}
                  alt={"Knowledge Partners"}
                />
              </figure>
              <h4>Knowledge Partners</h4>
            </div>
            <ul>
              <li>
                <h6>Membership Types</h6>
                <div className={styles.blueArrow}>
                  Knowledge Hub Partnership
                </div>
                <div className={styles.blueArrow}>
                  Collaborative Academic Center
                </div>
                <div className={styles.blueArrow}>
                  Regional / Nodal Institutional Partner
                </div>
              </li>
              <li>
                {" "}
                <h6>Requirements</h6>
                <div className={styles.blueArrow}>
                  Recognized and accredited academic institution
                </div>
                <div className={styles.blueArrow}>
                  Formal MoU or institutional agreement
                </div>
                <div className={styles.blueArrow}>
                  Designated institutional liaison / coordinator
                </div>
              </li>
              <li>
                <h6>Commitment</h6>
                <div className={styles.blueArrow}>
                  Host or co-host academic events (minimum annual engagement recommended)
                </div>
                <div className={styles.blueArrow}>
                  Promote collaborative research and mentorship participation
                </div>
                <div className={styles.blueArrow}>
                  Encourage faculty and student involvement in IMPARC initiatives
                </div>
                <div className={styles.blueArrow}>
                  Support institutional compliance with academic integrity standards
                </div>
              </li>
            </ul>
            <button className={styles.cardBtn}>View Full Policy</button>
          </div>
          <div className={styles.card}>
            <div className={styles.heading}>
              <figure>
                <img
                  src={MembershipPoliciesImg3}
                  alt={"Governance Framework"}
                />
              </figure>
              <h4>Governance Framework</h4>
            </div>
            <ul>
              <li>
                <h6>Committee Structure</h6>
                <div className={styles.blueArrow}>
                  Governing Academic Council (GAC)
                </div>
                <div className={styles.blueArrow}>
                  Advisory Boards (National / International)
                </div>
                <div className={styles.blueArrow}>
                  Executive & Coordination Committees
                </div>
              </li>
              <li>
                <h6>Decision-Making Process</h6>
                <div className={styles.blueArrow}>
                  Merit-based and consensus-driven approach
                </div>
                <div className={styles.blueArrow}>
                  Transparent evaluation and review mechanisms
                </div>
                <div className={styles.blueArrow}>
                  Documented voting and selection procedures where applicable
                </div>
              </li>
              <li>
                <h6>Accountability & Oversight</h6>
                <div className={styles.blueArrow}>
                  Periodic performance and activity review
                </div>
                <div className={styles.blueArrow}>
                  Stakeholder feedback systems
                </div>
                <div className={styles.blueArrow}>
                  Compliance with ethical and regulatory standards
                </div>
              </li>
            </ul>
            <button className={styles.cardBtn}>View Full Policy</button>
          </div>
        </div>
      </div>
    </section>
  );
}
